/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/autoCapitalizationFilter.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoInputField implements angular.IDirective {

        restrict = "E";
        scope = {
            name: "@",
            currentValue: "=ngModel",
            contentKey: "@",
            maxLength: "=",
            disabled: "=ngDisabled",
            required: "=ngRequired",
            placeholder: "@",
            color: '=?',
            tabIndex: '@',
            pattern: '=ngPattern',
            patternError: "@?",
            customStyle: '=?',
            ngBlur: "&?",
            ngFocus: "&?",
            ngChange: "&?",
            onEnter: "&",
            onClear: "&",
            enforcePattern: "@",
            inputType: "@?",
            canClear: "=?",
            showCharLimit: "=?",
            size:"=?",
            allowInvalid: "=?", // this needs to be true alongside showCharLimit when there's a pattern that validates the limit 
            helperText: "@?"
        };

        template = `<div>
                        <div class="meevo_input_wrapper">
                            <label translate="{{::contentKey}}"></label>
                            <div ng-class="{'ng-dirty required_red_bubble ' : (required && !currentValue)}"></div>
                        </div>
                        <div ng-form="inputFieldForm" style="position: relative;">
                            <input id="{{contentKey + placeholder +  $parent.$index }}" placeholder="{{placeholder}}" 
                                    tabindex={{tabIndex}}
                                    ng-pattern="pattern"
                                    maxlength="{{maxLength}}"
                                    autocomplete="off"
                                    ng-style="inputStyle"
                                    ng-blur="blur()"
                                    ng-focus="focus()"
                                    ng-change="ngChange()"
                                    name="{{name}}"
                                    size="{{size}}"
                                    ng-class="{'red_border_invalid' : (!currentValue && required)}"
                                    ng-model="currentValue" ng-disabled="disabled" ng-required="required"
                                    ng-model-options="{ allowInvalid: allowInvalid}"
                                    type="{{inputType || 'text'}}"
                                    />
                            <button class="meevo-typeahead-clearFilter" ng-disabled="disabled" ng-click="clear()" type="button" tabindex="-1" ng-if="canClear"></button>
                        </div>
                        <span layout="row" layout-align="end center" ng-if="showCharLimit">{{ countLeft }} Characters Left</span>
                        <span style="border:none; color:red;" ng-show="inputFieldForm.$error.pattern" translate="{{patternError}}"></span>
                        <span ng-if="helperText" class="helper-text">{{helperText | translate}}<span>
                    </div>
                    `;

        constructor(private $filter: angular.IFilterService, private $compile: angular.ICompileService, private $timeout) {

        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes, formCtrl: angular.IFormController) => {
            var filter = this.$filter;
            var enforcePattern = (!!scope.enforcePattern && (scope.enforcePattern == "1" || scope.enforcePattern.toLowerCase() == "true"));
            //scope.patternError = scope.patternError || 'LABEL_INVALID_DATA'

            if (scope.currentValue && scope.maxLength) {
                scope.countLeft = scope.maxLength - scope.currentValue.length;
            } else if (scope.maxLength) {
                scope.countLeft = scope.maxLength;
            }

            if (typeof scope.color === 'undefined') {
                scope.color = '#512DA8';
            }

            scope.$watch(() => scope.customStyle, (newValue) => {
                if (typeof scope.customStyle === 'undefined') {
                    scope.customStyle = {};
                }

                scope.inputStyle = angular.extend({}, scope.customStyle);
            });

            if (scope.showCharLimit) {
                scope.$watch(() => scope.currentValue,
                    function (currentValue, prevValue) {
                        if (scope.maxLength) {
                            scope.countLeft = currentValue != null ? scope.maxLength - currentValue.length : scope.maxLength;
                        }
                    });
            }
            // If enter text and then immediately hit clear button, blur will fire
            // before clear event.  Need timer so if clear is clicked in this case, it can
            // cancel out blur handler
            var blurTimer;
            scope.blur = () => {
                blurTimer = this.$timeout(() => {
                    if (angular.isDefined(scope.ngBlur)) {
                        scope.ngBlur();
                    }
                }, 200);
            }

            scope.focus = () => {
                if (angular.isDefined(scope.ngFocus)) {
                    scope.ngFocus();
                }
            }

            scope.clear = () => {
                angular.element(element).find("input").focus();
                scope.currentValue = undefined;
                if (angular.isDefined(blurTimer)) {
                    this.$timeout.cancel(blurTimer);
                }
                this.$timeout(() => {
                    if (angular.isDefined(scope.onClear)) {
                        scope.onClear();
                    }

                    if (angular.isDefined(scope.ngChange)) {
                        scope.ngChange();
                    }
                    else if (angular.isDefined(scope.onEnter)) {
                        scope.onEnter();
                    }
                    else if (angular.isDefined(scope.onBlur)) {
                        scope.onBlur();
                    }
                });
            }

            element.on("click", (event: JQueryEventObject) => {
                if (!scope.isDisabled) {
                    let target: any = event.target || event.srcElement;
                    if (target.id === scope.id) {
                        target.select();
                    }
                    event.preventDefault();
                }
            });

            element.on("keydown", (event: JQueryEventObject) => {

                if (_.contains([46, 8, 9, 27, 13, 110, 190], event.keyCode) ||
                    // Allow: Ctrl+A
                    (event.keyCode === 65 && event.ctrlKey) ||
                    // Allow: Ctrl+C
                    (event.keyCode === 67 && event.ctrlKey) ||
                    // Allow: Ctrl+X
                    (event.keyCode === 88 && event.ctrlKey) ||
                    // Allow: home, end, left, right
                    (event.keyCode >= 35 && event.keyCode <= 39)) {

                    if (event.keyCode === 13 && _.isFunction(scope.onEnter)) {
                        scope.onEnter({ event: event });
                    }
                    // let it happen, don't do anything
                    return;
                }

                // strictly follow pattern to each key stroke
                if (enforcePattern && scope.pattern && scope.pattern.constructor.name == "RegExp") {
                    let newStr: string = ((scope.currentValue ? scope.currentValue : "") + event.key);
                    let matches = newStr.match(scope.pattern);
                    if (!matches || matches.length != 1) {
                        event.preventDefault();
                        return;
                    }
                }
            });

        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($filter, $compile, $timeout) => {
                return new MeevoInputField($filter, $compile, $timeout);
            };

            directive.$inject = ["$filter", "$compile", "$timeout"];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoInputField", MeevoInputField.factory());
}
